const APP_LANGUAGE_KEY = 'run4fun.app.language'
const LEGACY_LANGUAGE_KEYS = ['run4fun.instructions.language', 'run4fun.appHelp.language']
const SUPPORTED_LANGUAGES = new Set(['pt', 'en', 'es'])
// Build-time default language (per deployment). Falls back to 'pt' when unset/invalid,
// so RUN 4 FUN stays Portuguese while the ClubSpace demo sets VITE_DEFAULT_LANGUAGE=en.
const ENV_DEFAULT_LANGUAGE = String(import.meta.env?.VITE_DEFAULT_LANGUAGE || '').toLowerCase()
const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.has(ENV_DEFAULT_LANGUAGE) ? ENV_DEFAULT_LANGUAGE : 'pt'

export function normalizeAppLanguage(language) {
  return SUPPORTED_LANGUAGES.has(language) ? language : DEFAULT_LANGUAGE
}

export function resolveAppLanguage() {
  try {
    const primary = globalThis.localStorage?.getItem(APP_LANGUAGE_KEY)
    if (primary) return normalizeAppLanguage(primary)

    for (const key of LEGACY_LANGUAGE_KEYS) {
      const value = globalThis.localStorage?.getItem(key)
      if (value) return normalizeAppLanguage(value)
    }
  } catch {
    // Ignore storage errors and fallback to app default language.
  }

  return DEFAULT_LANGUAGE
}

export function persistAppLanguage(language) {
  const normalized = normalizeAppLanguage(language)
  try {
    globalThis.localStorage?.setItem(APP_LANGUAGE_KEY, normalized)
    LEGACY_LANGUAGE_KEYS.forEach((key) => {
      globalThis.localStorage?.setItem(key, normalized)
    })
  } catch {
    // Ignore storage failures; UI language still updates for this session.
  }
  return normalized
}
